import React, { useEffect, useState, useRef, createElement } from 'react';
import { motion } from 'framer-motion';
import { Play, Calendar, Clock, Search, Mic } from 'lucide-react';
import { PageTransition } from '../components/PageTransition';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
// Real Episode Data from Buzzsprout / Spotify
const episodes = [{
  id: 18,
  title: 'Hope in the Middle of the Storm — Pastor Charlie Mitchell',
  guest: 'Pastor Charlie Mitchell',
  description: 'On this episode of the 3 Doves Podcast, Pastor Charlie Mitchell shares his journey from growing up in Key West and Fort Myers, to losing his father to cancer at just 13 years old and stepping into adult responsibilities far too early. Charlie opens up about finding faith through youth ministry, missions work around the world, meeting his wife Erin in Copenhagen, and walking through deep loss, chronic illness, and a stage four kidney diagnosis that ultimately led to a life-saving transplant in 2023.',
  date: 'May 15, 2026',
  duration: '1 hr 1 min',
  category: 'Faith',
  spotifyUrl: 'https://open.spotify.com/episode/5nLNKOKVfFp7UOUjvDl2Tx?si=Tzc-Tf3pRKSgTWEPxBTmzA'
}, {
  id: 17,
  title: "Krista Klossner — It's Okay to Not Be Okay PART 2",
  guest: 'Krista Klossner',
  description: "The conversation continues. In Part 2, Krista Klossner picks up where Part 1 left off — going deeper into her story of faith, surrender, and the truth that nothing is counted as a loss when you're walking with God.",
  date: 'May 9, 2026',
  duration: '50 min',
  category: 'Faith',
  spotifyUrl: 'https://open.spotify.com/episode/7w8hZFEyNDiMk1ZtKYggMq?si=5h4g_NX2QlaCuCy-R6ysMg'
}, {
  id: 16,
  title: "Krista Klossner — It's Okay to Not Be Okay PART 1",
  guest: 'Krista Klossner',
  description: "Join us for a powerful conversation with Krista Klossner as she shares her story of faith, surrender, and discovering that nothing is counted as a loss when you're walking with God. In Part 1, Krista opens up about the moments that shaped her journey and the truth that it's okay to not be okay.",
  date: 'May 2, 2026',
  duration: '50 min',
  category: 'Faith',
  spotifyUrl: 'https://open.spotify.com/episode/5Ypjxx0MxrjnUAg47wlq9O?si=PNtQOn0NTIiRdFw0tc9wQw'
}, {
  id: 15,
  title: 'Take Refuge — Dolphin Trainer Erin Morrison — Living the Uncomfortable Life',
  guest: 'Erin Morrison',
  description: "Erin Morrison serves as the Ends Sailing Director for Ends Adventures. Erin felt called by God to pursue camp programs for at-risk youth, both overseas and locally. Having a background in biology, her heart is to use God's creation to show youth how deeply loved they are. Grounded in Romans 12:2, Erin talks about God's plan in providing Refuge for Erin going all in and not pursuing a life of comfort.",
  date: 'Apr 25, 2026',
  duration: '50 min',
  category: 'Faith',
  spotifyUrl: 'https://open.spotify.com/episode/63Dwqu74u1ipzyw1Lfk2BN?si=4vWlLfk-SOq41uiPvsWQXQ'
}, {
  id: 14,
  title: 'Matt Crosson — Walking by Faith in Business and Life',
  guest: 'Matt Crosson',
  description: 'Matt Crosson joins the podcast to share his journey of faith through the world of business and everyday life. Matt opens up about the challenges, victories, and moments of surrender that have shaped his walk with God.',
  date: 'Apr 18, 2026',
  duration: '50 min',
  category: 'Faith',
  spotifyUrl: 'https://open.spotify.com/episode/1VjWqTTxQ3OKNueDnMvmC1?si=7UPQYCXISkmWPT8BnFl2jg'
}, {
  id: 13,
  title: 'Streetlights — Cody Grube — Illuminating Scripture Through Music',
  guest: 'Cody Grube',
  description: 'Cody Grube, founder of Streetlights, joins the podcast to share how he is making the Bible accessible through music and spoken word. Cody talks about his passion for bringing Scripture to life in a way that resonates with people from all walks of life.',
  date: 'Apr 11, 2026',
  duration: '55 min',
  category: 'Mission',
  spotifyUrl: 'https://open.spotify.com/episode/6rWWtBOJcpCSI2vC7eErcc?si=gQwStn_bR-qQWFvJLEdwiA'
}, {
  id: 12,
  title: "Who's Gonna Roll the Stone Away",
  guest: 'Jason Pawloski',
  description: "Host Jason Pawloski shares the Easter resurrection story from Mark 16:1–8, focusing on the women who go to Jesus' tomb wondering who will roll away the large stone, only to find it already moved and hear that Jesus has risen. He highlights how they walked in faith despite an obstacle they couldn't overcome, and connects the stone to the pressures, fear, regret, uncertainty, and hesitation people face today.",
  date: 'Apr 4, 2026',
  duration: '30 min',
  category: 'Easter',
  spotifyUrl: 'https://open.spotify.com/episode/1iuDCgkwxrLBuMVk7auwTe?si=zgO0dRzWSGOPBCpD2ZV0xQ'
}, {
  id: 11,
  title: 'Music, Mission & Ministry — A Conversation with Iskander',
  guest: 'Iskander (Jesús Martínez)',
  description: 'Born Jesús Martínez in Venezuela, Iskander is a dynamic reggae musician and passionate missionary whose work spans music, ministry, and humanitarian outreach worldwide. Through his powerful sound, he conveys messages of love, hope, and faith—reaching audiences across cultures while serving marginalized communities, from the homeless to at-risk youth. Whether on stage or in the field, Iskander uses his music and faith to make a lasting impact, one song and one mission at a time.',
  date: 'Mar 28, 2026',
  duration: '55 min',
  category: 'Mission',
  spotifyUrl: 'https://open.spotify.com/episode/3bDtfcX8c7dRvH29wygmzB?si=7EqDTOw9TZqRwETk0tN6xA'
}, {
  id: 10,
  title: "Purpose at the Intersection — How Prayer, God's Protection and Healing Reached Others",
  guest: 'Wayne Schwartz',
  description: 'In this part two conversation, Jason interviews Wayne Schwartz about how God "lined up" events surrounding Rachel\'s wedding and the serious car accident afterward. Wayne describes feeling a shock wave during the crash and believes God healed and protected him — leaving him without even a bruise — so he could be there for his family when they needed him most.',
  date: 'Mar 21, 2026',
  duration: '49 min',
  category: 'Faith',
  spotifyUrl: 'https://open.spotify.com/episode/4OpAP35TOjPU15p1UKkAX3?si=VcWO4svuTzqPdTwkY41L0w'
}, {
  id: 9,
  title: 'Death to Home: Living the Abundant Life',
  guest: 'The Schwartz Family',
  description: "Host Jason Pawloski interviews Wayne and Michelle Schwartz and their daughters, Emma and Rachel, about an Oct. 13 car crash in rural Michigan after a nephew's wedding. Their rental car entered a blinking-light intersection, was struck on the passenger side by a heavier vehicle, slammed into a wooden telephone pole — and what followed was a powerful story of faith, family, and the abundant life found even in the darkest moments.",
  date: 'Mar 14, 2026',
  duration: '51 min',
  category: 'Faith',
  spotifyUrl: 'https://open.spotify.com/episode/4mIITXmQE29cGzkPj6i88B?si=-222unrAT_umMak7GhuWjg'
}, {
  id: 8,
  title: 'Nothing is Wasted — Jimmy Akers — Addictions, Identity and Love',
  guest: 'Jimmy Akers',
  description: 'Jimmy Akers blends his experience of 19+ years of serving people at their most critical intersections in life and providing support to help improve their mental health, as a clean, funny, speaker and storyteller. Jimmy has spoken 1,000+ times around the world, and shares his struggles with anxiety, depression, loss and a suicide attempt.',
  date: 'Mar 7, 2026',
  duration: '59 min',
  category: 'Identity',
  spotifyUrl: 'https://open.spotify.com/episode/4YF0jNbcTWNam3nXdO88vS?si=Po7coKNCShyWl9Q6DB0Rkg'
}, {
  id: 7,
  title: 'Corporate to Called — Francisco Shares His Rich Heritage of Family, Faith, and Favor',
  guest: 'Francisco Miyares Jr.',
  description: 'In this compelling episode, Francisco Miyares Jr. opens up about his journey from the structure and success of the corporate world to answering a deeper calling on his life. Rooted in a rich heritage of family, faith, and favor, he shares how stepping away from a 15-year corporate career led him into full-time ministry and a life fully dedicated to advancing the Gospel.',
  date: 'Feb 28, 2026',
  duration: '52 min',
  category: 'Calling',
  spotifyUrl: 'https://open.spotify.com/episode/79QQTpd7sZaxeIXfE2f1hc?si=PaCFBAHXQSGADxmAsXB9yA'
}, {
  id: 6,
  title: 'Addiction to Adventure - A Hike into the Presence of God',
  guest: 'Lexi Loofboro',
  description: 'Lexi Loofboro loves anything that brings together faith, health, and people. She is married to her husband, Ian Loofboro, and together they serve the world through coaching, and their stand is to be love, hope and transformation. As a Hiking Director, Lexi takes those same passions and leads others to step away from the everyday and into adventures with God!',
  date: 'Feb 22, 2026',
  duration: '50 min',
  category: 'Adventure',
  spotifyUrl: 'https://spotifycreators-web.app.link/e/ZkygbZ4cX0b'
}, {
  id: 5,
  title: 'A Band of Brothers - The Power of Transformative Love',
  guest: 'Andrew, Caleb & JJ',
  description: 'In this episode, Jason sits down with three college students — Andrew, Caleb, and JJ — to explore what it means to be brothers in Christ. They dive into the power of transformative love, how authentic brotherhood shapes faith, and why the next generation is hungry for real community rooted in Jesus.',
  date: 'Feb 14, 2026',
  duration: '48 min',
  category: 'Brotherhood',
  spotifyUrl: 'https://open.spotify.com/episode/0GfsHrolJsi0UAOTYJmcP4?si=QIMcX_yIT9W2e0uy_CZ7lg'
}, {
  id: 4,
  title: 'A Warriors Stance - Being in REAL Relationship',
  guest: 'Justin Hanneken',
  description: "In this episode of the Three Doves Podcast, host Jason Pawloski welcomes back guest Justin Hanneken, Executive Director of Ends of Earth Adventures and Associate Pastor. They delve into Justin's transformative journey, from starting cycling to building real, authentic relationships rooted in faith.",
  date: 'Feb 7, 2026',
  duration: '43 min',
  category: 'Relationships',
  spotifyUrl: 'https://open.spotify.com/episode/4Jci4PYyVQ7HoRSNHKKRBt'
}, {
  id: 3,
  title: 'A Warriors Ride to Salvation and Beyond',
  guest: 'Justin Hanneken',
  description: 'In this episode, host Jason Pawloski sits down with Justin Hanneken, Executive Director of Ends of the Earth Adventures and associate pastor, for the first part of a powerful two-part conversation. Justin shares his remarkable journey from being lost to finding salvation and beyond.',
  date: 'Feb 1, 2026',
  duration: '42 min',
  category: 'Testimony',
  spotifyUrl: 'https://open.spotify.com/episode/4n7iOViUYM8hg3L4P27v1U?si=9yeXgtkTSb-Lz69F0XpP1g'
}, {
  id: 2,
  title: 'Finding Identity and Purpose in God by Learning to "Be Still" Amidst Crisis and Betrayal',
  guest: 'Josh Phelps',
  description: 'In this episode, we sit down with Josh Phelps, a man whose life story is a testament to the power of divine protection and the beauty of restoration. From the high-stakes world of law enforcement to the front lines of disaster restoration, Josh shares how God taught him to be still and find his true identity and purpose.',
  date: 'Jan 25, 2026',
  duration: '45 min',
  category: 'Faith',
  spotifyUrl: 'https://open.spotify.com/episode/77Ie7kgLCKcZGh7EBAtJl3?si=_nUsG9ebSHOZEg2QEHBZCA'
}, {
  id: 1,
  title: 'The Process of Pain',
  guest: 'Chris Horseman',
  description: "Pain is something we all try to avoid, yet it's often the very thing that shapes us most. In this episode, we sit down with Chris Horseman of Horseman's Landscape to talk honestly about what pain looks like when it shows up in real life — not as a theory, but as a process. Chris shares his journey through adversity, responsibility, and refinement, and how pain — when faced instead of escaped — can become a tool that forms character, resilience, and purpose.",
  date: 'Jan 17, 2026',
  duration: '1 hr',
  category: 'Growth',
  spotifyUrl: 'https://open.spotify.com/episode/6BAT0ZmBNNcgxAslAVWTZh?si=hkqEEC3bTqu0TIhzjAYp4g'
}];
const SPOTIFY_SHOW_URL = 'https://open.spotify.com/show/5nWVRvG1GtlfUXUfN77LfL';
export function PodcastsPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const buzzsproutRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (buzzsproutRef.current) {
      buzzsproutRef.current.innerHTML = '';
      const container = document.createElement('div');
      container.id = 'buzzsprout-large-player';
      buzzsproutRef.current.appendChild(container);
      const script = document.createElement('script');
      script.src = 'https://www.buzzsprout.com/2590035.js?container_id=buzzsprout-large-player&player=large';
      script.type = 'text/javascript';
      script.charset = 'utf-8';
      buzzsproutRef.current.appendChild(script);
    }
    return () => {
      if (buzzsproutRef.current) {
        buzzsproutRef.current.innerHTML = '';
      }
    };
  }, []);
  const filteredEpisodes = episodes.filter(ep => ep.title.toLowerCase().includes(searchTerm.toLowerCase()) || ep.guest.toLowerCase().includes(searchTerm.toLowerCase()));
  return <PageTransition data-id="element-629">
      <div className="pt-24 pb-16 min-h-screen" data-id="element-630">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-631">
          {/* Header */}
          <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-632">
            <div data-id="element-633">
              <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-634">
                All Episodes
              </h1>
              <p className="text-white/80 text-lg" data-id="element-635">
                Listen to the latest conversations.
              </p>
            </div>

            {/* Search Bar */}
            <div className="relative w-full md:w-72" data-id="element-636">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-637">
                <Search className="h-5 w-5 text-white/40" data-id="element-638" />
              </div>
              <input type="text" placeholder="Search episodes..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-dark-500 rounded-md leading-5 bg-dark-800 text-white placeholder-white/40 focus:outline-none focus:bg-dark-700 focus:border-gold-500 transition duration-150 ease-in-out sm:text-sm" data-id="element-639" />
            </div>
          </div>

          {/* Buzzsprout Player */}
          <div className="mb-12 bg-dark-800 rounded-2xl p-6 border border-dark-600" data-id="element-640">
            <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-641">
              Listen to All Episodes
            </h2>
            <div ref={buzzsproutRef} className="w-full" data-id="element-642" />
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-643">
            {filteredEpisodes.map(ep => <Card key={ep.id} className="flex flex-col h-full bg-dark-700 border-dark-600" data-id="element-644">
                <div className="p-6 flex flex-col h-full" data-id="element-645">
                  <div className="flex justify-between items-start mb-4" data-id="element-646">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gold-500/10 text-gold-500" data-id="element-647">
                      {ep.category}
                    </span>
                    <span className="text-white/40 text-xs font-mono" data-id="element-648">
                      EP {ep.id}
                    </span>
                  </div>

                  <h3 className="text-xl font-serif font-bold text-white mb-1 line-clamp-2 hover:text-gold-400 transition-colors cursor-pointer" data-id="element-649">
                    {ep.title}
                  </h3>
                  <p className="text-sm text-gold-500 mb-4 font-medium" data-id="element-650">
                    with {ep.guest}
                  </p>

                  <p className="text-white/70 text-sm mb-6 flex-grow line-clamp-3" data-id="element-651">
                    {ep.description}
                  </p>

                  <div className="flex items-center justify-between pt-4 border-t border-dark-600 mt-auto" data-id="element-652">
                    <div className="flex items-center space-x-4 text-xs text-white/50" data-id="element-653">
                      <span className="flex items-center" data-id="element-654">
                        <Calendar className="w-3 h-3 mr-1" data-id="element-655" /> {ep.date}
                      </span>
                      <span className="flex items-center" data-id="element-656">
                        <Clock className="w-3 h-3 mr-1" data-id="element-657" /> {ep.duration}
                      </span>
                    </div>
                    <a href={ep.spotifyUrl} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-gold-500 flex items-center justify-center text-dark-900 hover:scale-110 transition-transform shadow-lg shadow-gold-500/20" data-id="element-658">
                      <Play className="w-4 h-4 fill-current ml-0.5" data-id="element-659" />
                    </a>
                  </div>
                </div>
              </Card>)}
          </div>

          {filteredEpisodes.length === 0 && <div className="text-center py-20" data-id="element-660">
              <p className="text-white/60 text-lg" data-id="element-661">
                No episodes found matching your search.
              </p>
            </div>}

          {/* Listen on Spotify Banner */}
          <div className="mt-12 bg-dark-800 rounded-xl p-8 text-center border border-dark-600" data-id="element-662">
            <h3 className="text-2xl font-serif font-bold text-white mb-3" data-id="element-663">
              Listen on Spotify
            </h3>
            <p className="text-white/60 mb-6" data-id="element-664">
              Follow 3 Doves Podcast on Spotify to get notified when new
              episodes drop.
            </p>
            <a href={SPOTIFY_SHOW_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 bg-[#1DB954] text-white font-medium rounded-full hover:bg-[#1ed760] transition-colors shadow-lg" data-id="element-665">
              <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="currentColor" data-id="element-666">
                <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" data-id="element-667" />
              </svg>
              Follow on Spotify
            </a>
          </div>
        </div>
      </div>
    </PageTransition>;
}